import { render, staticRenderFns } from "./md-lazy.vue?vue&type=template&id=42e38777&"
import script from "./md-lazy.vue?vue&type=script&lang=js&"
export * from "./md-lazy.vue?vue&type=script&lang=js&"
import style0 from "./md-lazy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports